
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-ffb05eec\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./identiteSalarie.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./identiteSalarie.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ffb05eec\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./identiteSalarie.vue.html"),
  /* scopeId */
  "data-v-ffb05eec",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ficheSalarie/identite/identiteSalarie.vue.html
// module id = 2mX1
// module chunks = 2